module.exports = __webpack_public_path__ + "static/img/img.e0b35c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404/img.png
// module id = i8gO
// module chunks = 78